import { UPDATE_SERVICE_TYPE_REDUCER } from "store/actionTypes";
import { ActionType, ServiceTypesData } from "utils/modals";

export const ServiceTypeReducer = (
  state: ServiceTypesData = new ServiceTypesData(),
  action: ActionType
) => {
  switch (action.type) {
    case UPDATE_SERVICE_TYPE_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
